import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function JiraIcon2(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        d="M20.2543 3H11.5884C11.5884 5.16 13.3366 6.909 15.4972 6.909H17.0909V8.45138C17.0909 10.6114 18.8399 12.3604 20.9999 12.3604V3.74569C20.9998 3.54796 20.9212 3.35838 20.7814 3.21857C20.6416 3.07876 20.452 3.00015 20.2543 3Z"
        fill="#2684FF"
      />
      <path
        d="M15.96 7.32001H7.29395C7.29395 9.47982 9.04238 11.2288 11.2022 11.2288H12.7967V12.7712C12.7967 14.9312 14.5457 16.6802 16.7057 16.6802V8.06551C16.7054 7.86783 16.6267 7.67834 16.487 7.53856C16.3472 7.39878 16.1577 7.32031 15.96 7.32001Z"
        fill="url(#paint0_linear_10640_68173)"
      />
      <path
        d="M11.6661 11.6396H3C3 13.8004 4.74825 15.5486 6.909 15.5486H8.50275V17.0918C8.50275 19.2518 10.2517 21 12.4116 21V12.3861C12.4114 12.1884 12.3328 11.9988 12.193 11.8589C12.0533 11.719 11.8638 11.64 11.6661 11.6396Z"
        fill="url(#paint1_linear_10640_68173)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10640_68173"
          x1="16.5253"
          y1="7.32976"
          x2="12.8383"
          y2="11.1315"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.176" stopColor="#0052CC" />
          <stop offset="1" stopColor="#2684FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10640_68173"
          x1="12.4807"
          y1="11.673"
          x2="8.21775"
          y2="15.8205"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.176" stopColor="#0052CC" />
          <stop offset="1" stopColor="#2684FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
